import clsx from 'clsx';
import styles from './Spinner.module.css';

const SPINNER_SIZE_PX = {
  sm: 24,
  md: 36,
  lg: 48,
};

function resolveSpinnerSize(size) {
  if (typeof size === 'number') {
    return `${size}px`;
  }

  const normalized = String(size ?? 'sm')
    .trim()
    .toLowerCase();
  const mapped = SPINNER_SIZE_PX[normalized];
  if (mapped != null) {
    return `${mapped}px`;
  }

  return String(size ?? '24px');
}

export function Spinner({ size = 'sm', className = '', ariaLabel = 'Loading' }) {
  const px = resolveSpinnerSize(size);
  return (
    <span
      className={clsx(styles.spinner, className)}
      style={{ width: px, height: px }}
      role="status"
      aria-label={ariaLabel}
    />
  );
}

export function SpinnerWrap({
  className = '',
  ariaLabel = 'Loading',
  minHeight = 360,
  size = 'lg',
}) {
  const resolvedMinHeight = typeof minHeight === 'number' ? `${minHeight}px` : String(minHeight);

  return (
    <div
      className={clsx(styles.wrap, className)}
      style={{ minHeight: resolvedMinHeight }}
      aria-label={ariaLabel}
    >
      <Spinner size={size} ariaLabel={ariaLabel} />
    </div>
  );
}
